module.exports = {

  getFormattedDateStatus: (dateStatus) => {
    dateStatus = dateStatus.replace(/\s+$/, '');
    let formattedDateStatus = {}
    formattedDateStatus.dateStatus = dateStatus
    let start = dateStatus.indexOf('(')
    let end = dateStatus.indexOf(')')
    if (start > -1 && end > -1) {
      formattedDateStatus.dateStatus = dateStatus.slice(0, start);
      formattedDateStatus.days = dateStatus.slice(start, end + 1)
    }
    return formattedDateStatus
  }
};